// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoomSchemeSize-module__main--lOxG0 {
    border: 1px solid var(--color-general-black);
    padding: 5px 12px;
    border-radius: 12px;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    background-color: var(--color-general-white);
    white-space: nowrap;
    user-select: none;
}

.RoomSchemeSize-module__rotated--IrIxq {
    transform: rotate(90deg);
}

.RoomSchemeSize-module__hidden--DlIpg {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/RoomSchemeSize/RoomSchemeSize.module.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,4CAA4C;IAC5C,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".main {\n    border: 1px solid var(--color-general-black);\n    padding: 5px 12px;\n    border-radius: 12px;\n    font-size: 14px;\n    line-height: 16px;\n    font-weight: 500;\n    background-color: var(--color-general-white);\n    white-space: nowrap;\n    user-select: none;\n}\n\n.rotated {\n    transform: rotate(90deg);\n}\n\n.hidden {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `RoomSchemeSize-module__main--lOxG0`,
	"rotated": `RoomSchemeSize-module__rotated--IrIxq`,
	"hidden": `RoomSchemeSize-module__hidden--DlIpg`
};
export default ___CSS_LOADER_EXPORT___;
